// extracted by mini-css-extract-plugin
module.exports = {"container":"___not-found__container__XAq6R","footer":"___not-found__footer__61wq3"};